<template>
  <div>
    <header class="f-header js-f-header position-fixed" ref="refHeader">
      <div class="f-header__mobile-content container max-width-lg">
        <router-link to="/" title="2022 曜越單車旗艦館">
          <img src="@/assets/images/ttbike_logo_tw.png" class="logo" alt="2022 曜越單車旗艦館">
        </router-link>

        <button class="reset anim-menu-btn js-anim-menu-btn f-header__nav-control js-tab-focus" aria-label="Toggle menu" ref="refNavButton">
          <i class="anim-menu-btn__icon anim-menu-btn__icon--close" aria-hidden="true"></i>
        </button>
      </div>

      <div class="f-header__nav" role="navigation" ref="refNavigation">
        <div class="f-header__nav-grid justify-between@md container max-width-lg">
          <div class="f-header__nav-logo-wrapper flex-grow flex-basis-0">
            <router-link to="/" title="2022 曜越單車旗艦館">
              <img src="@/assets/images/ttbike_logo_tw.png" class="logo" alt="2022 曜越單車旗艦館">
            </router-link>
          </div>

          <ul class="f-header__list flex-grow flex-basis-0 justify-center@md">
            <li class="f-header__item">
              <a href="" class="f-header__link" title="直播平台" @click.prevent="goThere(0)">直播平台</a>
            </li>
            <li class="f-header__item">
              <!-- <a href="" class="f-header__link" title="賽事獎勵" @click.prevent="goThere(4)">賽事獎勵</a> -->
              <router-link to="/Awards" class="f-header__link" @click="menuClose()">賽事獎勵</router-link>
            </li>
            <li class="f-header__item">
              <!-- <a href="" class="f-header__link" title="賽事資訊" @click.prevent="goThere(3)">賽事資訊</a> -->
              <router-link to="/Rules" class="f-header__link" @click="menuClose()">賽事資訊</router-link>
            </li>
            <li class="f-header__item">
              <!-- <a href="" class="f-header__link" title="選手名單" @click.prevent="goThere(2)">選手名單</a> -->
              <router-link to="/Players" class="f-header__link" @click="menuClose()">選手名單/成績</router-link>
            </li>
            <li class="f-header__item">
              <router-link to="/Equipment" class="f-header__link" @click="menuClose()">賽事推薦配備</router-link>
            </li>
            <li class="f-header__item">
              <!-- <a href="" class="f-header__link" title="注意事項" @click.prevent="goThere(3)">注意事項</a> -->
              <!-- <router-link to="/Album" class="f-header__link" @click="menuClose()">賽事相簿</router-link> -->
              <a href="https://album.thermaltake.bike/" class="f-header__link" title="賽事相簿" target="_blank">賽事相簿</a>
            </li>
            <li class="f-header__item">
              <router-link to="/Video" class="f-header__link" @click="menuClose()">賽事影音</router-link>
            </li>
          </ul>
          <ul class="f-header__list flex-grow flex-basis-0 justify-end@md">
            <li class="f-header__item"><a href="" class="f-header__btn btn btn--primary apply" @click.prevent="goThere(1)">我要報名</a></li>
            <li class="f-header__item">
              <a href="#" class="f-header__link">
                <span>賽事官方社群</span>
                <svg class="f-header__dropdown-icon icon" aria-hidden="true" viewBox="0 0 12 12">
                  <path d="M9.943,4.269A.5.5,0,0,0,9.5,4h-7a.5.5,0,0,0-.41.787l3.5,5a.5.5,0,0,0,.82,0l3.5-5A.5.5,0,0,0,9.943,4.269Z" />
                </svg>
              </a>
              <ul class="f-header__dropdown">
                <li>
                  <a href="https://www.facebook.com/thermaltakebicycle" title="曜越單車FB粉絲團" target="_blank" class="f-header__dropdown-link">
                    <font-awesome-icon :icon="[`fa-brands`, `facebook-square`]"/>&nbsp;&nbsp;曜越單車FB粉絲團
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/thermaltake_bicycle/" title="曜越單車IG" target="_blank" class="f-header__dropdown-link">
                    <font-awesome-icon :icon="[`fa-brands`, `instagram-square`]"/>&nbsp;&nbsp;曜越單車IG
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/TTBiketaipei" title="曜越單車旗艦館FB粉絲團" target="_blank" class="f-header__dropdown-link">
                    <font-awesome-icon :icon="[`fa-brands`, `facebook-square`]"/>&nbsp;&nbsp;曜越單車旗艦館FB粉絲團
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/thermaltake_bicycle_shop/" title="曜越單車旗艦館IG" target="_blank" class="f-header__dropdown-link">
                    <font-awesome-icon :icon="[`fa-brands`, `instagram-square`]"/>&nbsp;&nbsp;曜越單車旗艦館IG
                  </a>
                </li>
              </ul>
            </li>
            
          </ul>
        </div>
      </div>
    </header>
    <svg class="headerBg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform:rotate(180deg); transition: 0.3s" viewBox="0 0 1440 110" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0"><stop stop-color="rgba(255, 255, 255, 1)" offset="0%"/><stop stop-color="rgba(214, 214, 214, 1)" offset="100%"/></linearGradient></defs><path style="transform:translate(0, 0px); opacity:1" fill="url(#sw-gradient-0)" d="M0,55L120,51.3C240,48,480,40,720,44C960,48,1200,62,1440,62.3C1680,62,1920,48,2160,47.7C2400,48,2640,62,2880,58.7C3120,55,3360,33,3600,27.5C3840,22,4080,33,4320,34.8C4560,37,4800,29,5040,33C5280,37,5520,51,5760,60.5C6000,70,6240,73,6480,66C6720,59,6960,40,7200,31.2C7440,22,7680,22,7920,23.8C8160,26,8400,29,8640,27.5C8880,26,9120,18,9360,29.3C9600,40,9840,70,10080,80.7C10320,92,10560,84,10800,77C11040,70,11280,62,11520,51.3C11760,40,12000,26,12240,18.3C12480,11,12720,11,12960,18.3C13200,26,13440,40,13680,40.3C13920,40,14160,26,14400,18.3C14640,11,14880,11,15120,25.7C15360,40,15600,70,15840,77C16080,84,16320,70,16560,66C16800,62,17040,70,17160,73.3L17280,77L17280,110L17160,110C17040,110,16800,110,16560,110C16320,110,16080,110,15840,110C15600,110,15360,110,15120,110C14880,110,14640,110,14400,110C14160,110,13920,110,13680,110C13440,110,13200,110,12960,110C12720,110,12480,110,12240,110C12000,110,11760,110,11520,110C11280,110,11040,110,10800,110C10560,110,10320,110,10080,110C9840,110,9600,110,9360,110C9120,110,8880,110,8640,110C8400,110,8160,110,7920,110C7680,110,7440,110,7200,110C6960,110,6720,110,6480,110C6240,110,6000,110,5760,110C5520,110,5280,110,5040,110C4800,110,4560,110,4320,110C4080,110,3840,110,3600,110C3360,110,3120,110,2880,110C2640,110,2400,110,2160,110C1920,110,1680,110,1440,110C1200,110,960,110,720,110C480,110,240,110,120,110L0,110Z"/></svg>
    
  </div>
</template>

<style lang="scss">
@use "~codyhouse-framework/main/assets/css/base/breakpoints" as *;
@use "~codyhouse-framework/main/assets/css/base/mixins" as *;
@import "@/assets/scss/common/flexi-header";

.headerBg {
  position: fixed;
  top: -1px;
  z-index: 90;
}
.f-header {
  // background: -moz-linear-gradient(top,#fff 0%,#d6d6d6 100%);
  // background: -webkit-linear-gradient(top,#fff 0%,#d6d6d6 100%);
  // background: linear-gradient(to bottom,#fff 0%,#d6d6d6 100%);
  background: transparent;
  z-index: 99;
}
.btn.apply {
  padding: 5px 8px;
}
.btn--primary:hover {
  background: var(--color-bg-darker) !important;
}
.logo {
  width: 70%;
  display: block;
}
.f-header__list {
  margin: 0;
}
.faIconWrap {
  display: flex;
}
.faIconBox {
  padding: 2px;
  border-right: 1px solid rgb(138, 138, 138);
}
.faIconBox:last-child {
  border-right: 0;
}
.faIconBox h5 {
  font-size: 12px;
  margin: 0;
}
.faIcon {
  padding: 1px;
}
.f-header__dropdown-link {
  font-size: 15px;
}
@media only screen and (max-width: 1399px) {
  .f-header__item {
    margin-right: 0;
  }
}
@media only screen and (max-width: 1200px) {
  .f-header {
    background: -moz-linear-gradient(top,#fff 0%,#d6d6d6 100%);
    background: -webkit-linear-gradient(top,#fff 0%,#d6d6d6 100%);
    background: linear-gradient(to bottom,#fff 0%,#d6d6d6 100%);
    // z-index: 3;
  }
  .f-header__link {
    font-size: 15px;
    padding: 3px;
  }
}
</style>

<script>
export default {
  inject: ['emitter'],
  methods: {
    goThere(id) {
      this.menuClose();
      this.$router.push(`/`);
      this.emitter.emit('emitgotoId', id)
    },
    menuClose() {
      this.$refs.refNavigation.classList.remove('f-header__nav--is-visible');
      this.$refs.refHeader.classList.remove('f-header--expanded');
      this.$refs.refNavButton.classList.remove('anim-menu-btn--state-b');
    },
  },
  // npm i codyhouse-framework
  mounted () {
    const frontEnd = document.createElement('script')
    frontEnd.setAttribute('src', './flexi-header.js')
    frontEnd.setAttribute('id', 'flexi-header-js')

    document.body.appendChild(frontEnd)
  },
  unmounted () {
    document.getElementById('flexi-header-js').remove()
  }
}
</script>
<!-- <template>
  <div>
    <header id="gHeader" class="f-header js-f-header position-relative">
      <div class="f-header__mobile-content">
        <button class="reset anim-menu-btn js-anim-menu-btn f-header__nav-control js-tab-focus" aria-label="Toggle menu">
          <i class="anim-menu-btn__icon anim-menu-btn__icon--close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="mainNav">
        <div class="mainLogo">
          <h1 title="2022 曜越單車旗艦館">
            <router-link to="/" title="2022 曜越單車旗艦館">
              <img src="@/assets/images/ttbike_logo_tw.png" alt="2022 曜越單車旗艦館">
            </router-link>
          </h1>
        </div>

        <div class="f-header__nav gMenu" role="navigation">
          <div class="f-header__nav-grid justify-between@md max-width-lg">
            <ul class="f-header__list flex-grow flex-basis-0 justify-center@md">
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/voteNow`" class="f-header__link">{{ $t('NAV.VOTE_NOW') }}</router-link>
              </li>
              <li class="f-header__item">
                <a href="" title="影音平台">影音平台</a>
              </li>
              <li class="f-header__item">
                <a href="" title="選手名單">選手名單</a>
              </li>
              <li class="f-header__item">
                <a href="" title="賽事資訊">賽事資訊</a>
              </li>
              <li class="f-header__item">
                <a href="" title="賽事獎勵">賽事獎勵</a>
              </li>
              <li class="f-header__item">
                <a href="" title="注意事項">注意事項</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</template> -->